import { useState, useEffect } from 'react';
import { ENDPOINTS, ADMIN_ENDPOINTS, adminFetch } from '../config';
import './Admin.css';

export default function AdminEducation() {
  const [education, setEducation] = useState('');
  const [education2, setEducation2] = useState('');
  const [resumeUrl, setResumeUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(ENDPOINTS.education)
      .then((r) => r.json())
      .then((arr) => {
        if (arr && arr[0]) {
          const row = arr[0];
          setEducation(row.education || '');
          setEducation2(row.education2 || '');
          setResumeUrl(row.resume_url || '');
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setSaving(true);
    try {
      const res = await adminFetch(ADMIN_ENDPOINTS.saveEducation, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ education, education2, resume_url: resumeUrl }),
      });
      const data = await res.json();
      if (data.error) setMessage(data.error);
      else setMessage('Saved successfully.');
    } catch {
      setMessage('Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Loading…</p>;

  return (
    <>
      <h1>Education</h1>
      <form onSubmit={handleSubmit}>
        {message && <p style={{ color: message.includes('success') ? '#3fb950' : 'var(--admin-danger)' }}>{message}</p>}
        <div className="form-group">
          <label>Tertiary Education (HTML)</label>
          <textarea name="education" rows={10} value={education} onChange={(e) => setEducation(e.target.value)} />
        </div>
        <div className="form-group">
          <label>High School (HTML)</label>
          <textarea name="education2" rows={10} value={education2} onChange={(e) => setEducation2(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Resume URL</label>
          <input type="url" value={resumeUrl} onChange={(e) => setResumeUrl(e.target.value)} />
        </div>
        <button type="submit" className="btn" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
      </form>
    </>
  );
}
